module.exports = __webpack_public_path__ + "img/ABPM.f23dba95.png";